import React from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'

const RestoreArchivedFiles = ({ order, readOnly }) => {
  const { formatMessage } = useIntl()
  
  const onClick = () => {
    if (confirm(formatMessage(messages.confirm))) {
      fetch(`/order/restoreOrderFiles.json?orderId=${order.uid}`, { 
          method: 'POST'
        }) 
        .then((response) => response.json())
        .then((response) => {
          if (response.success) {
            toastr.success(formatMessage(messages.success))
          } else {
            toastr.error(formatMessage(messages.error))
          }
        })
        .catch((error) => toastr.error(error))
    }
  }


  return (
    <Menu.Item key='restoreArchivedFiles'>
      {(props) => (
        <MenuButton {...props} onClick={onClick}>
          { formatMessage(messages.title) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default RestoreArchivedFiles
